module.exports = __webpack_public_path__ + "0929e2997059c983c03586c58ef0887a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WTA-Player-Zone_Headers.png
// module id = 515
// module chunks = 0